import {PharmacyLandingPageRefRestDto} from "@/api/pharma-cms-pharmacy/models";
import {MultilingualRestDtoModel} from "@/models/MultilingualRestDtoModel";

export class PharmacyLandingPageRefRestDtoModel implements PharmacyLandingPageRefRestDto {
    landing_page_id: MultilingualRestDtoModel;

    constructor(landing_page_id: MultilingualRestDtoModel) {
        this.landing_page_id = landing_page_id;
    }

    public static createWithDefaults(): PharmacyLandingPageRefRestDtoModel {
        return new this(MultilingualRestDtoModel.createWithDefaults());
    }

    public static cloneFrom(source: PharmacyLandingPageRefRestDto): PharmacyLandingPageRefRestDtoModel {
        // The screen writes one language at a time into landing_page_id, so it always needs a real
        // multilingual object there, even when the API leaves the field out entirely.
        return new this(
            source.landing_page_id
                ? MultilingualRestDtoModel.cloneFrom(source.landing_page_id)
                : MultilingualRestDtoModel.createWithDefaults()
        );
    }
}
